import { useEffect, useState } from "react";
import api from "@/lib/api";

// Areas that have listings ({name, slug, count, location}), fetched once per visit and shared by every user.
let cache = null;
let pending = null;

export default function useLocalities() {
    const [list, setList] = useState(cache || []);
    useEffect(() => {
        if (cache) return;
        pending = pending || api.get("/meta/localities").then((r) => (cache = r.data || [])).catch(() => []);
        let live = true;
        pending.then((l) => live && setList(l));
        return () => { live = false; };
    }, []);
    return list;
}
